import { Header2, InlineText1 } from '@cian/ui-kit';

import { FC } from 'react';

import { ShowCoworkingOperatorPhoneButton } from '../ShowCoworkingOperatorPhoneButton';
import { IconGlass } from '../UI/Icons';

import * as styles from './styles.css';

export const LearnMore: FC = () => {
  return (
    <div className={styles['root']}>
      <div className={styles['title']}>
        <IconGlass className={styles['icon']} />
        <Header2 as="span">Хотите узнать больше?</Header2>
      </div>
      <div className={styles['description']}>
        <InlineText1 as="span" color="black_100" fontWeight="normal">
          Наиболее полная информация находится у оператора коворкинга.
        </InlineText1>
      </div>
      <div className={styles['contacts']}>
        <ShowCoworkingOperatorPhoneButton />
      </div>
    </div>
  );
};

LearnMore.displayName = 'LearnMore';
